<template>
  <div class="emb-delete-account-wrap">
    <emb-page-title
      heading="Delete Your TradeBridge Account"
      subHeading="Submit an email request to permanently delete your account and personal data."
      backgroundicon="https://ashapura.s3.ap-south-1.amazonaws.com/api/banner/066d29a1-f338-4e0b-83cd-db92f52912e3.jpeg"
    >
    </emb-page-title>

    <section class="section-gap bg-delete-account">
      <v-container>
        <div class="delete-account-content delete-account-card">
          <div class="hero-block">
            <p class="hero-kicker">Privacy &amp; Account Control</p>
            <h1 class="page-heading">Delete Your TradeBridge Account</h1>
            <p class="intro-text">
              At TradeBridge, we respect your privacy. You can request permanent
              deletion of your TradeBridge account and personal data at any time.
            </p>
          </div>

          <div class="section-grid">
            <div class="section-card">
              <div class="section-head">
                <span class="section-badge">1</span>
                <h2>How to Request Account Deletion</h2>
              </div>
            <div class="section-body">
              <p>
                Account deletion requests are accepted only through email. Please send
                your request from your registered email address to:
              </p>
              <p class="email-highlight">
                <a href="mailto:info@tradebridge.co.in">info@tradebridge.co.in</a>
              </p>
            </div>
            </div>

            <div class="section-card">
              <div class="section-head">
                <span class="section-badge">2</span>
                <h2>Data That Will Be Deleted</h2>
              </div>
            <div class="section-body">
              <p>
                Once your request is processed, the following data is permanently removed:
              </p>
              <ul class="styled-list two-col-list">
                <li>User profile information</li>
                <li>Email address and login data</li>
                <li>App usage data</li>
                <li>Saved preferences</li>
                <li>Associated account records</li>
              </ul>
            </div>
            </div>

            <div class="section-card">
              <div class="section-head">
                <span class="section-badge">3</span>
                <h2>Data That May Be Retained</h2>
              </div>
            <div class="section-body">
              <p>
                In limited cases, some data may be retained temporarily for the
                following reasons:
              </p>
              <ul class="styled-list two-col-list">
                <li>Legal obligations</li>
                <li>Fraud prevention</li>
                <li>Security compliance</li>
              </ul>
            </div>
            </div>

            <div class="section-card">
              <div class="section-head">
                <span class="section-badge">4</span>
                <h2>Data Retention Period</h2>
              </div>
            <div class="section-body">
              <p>
                Any temporarily retained data is automatically deleted within 30 days
                after deletion processing is completed.
              </p>
            </div>
            </div>

            <div class="section-card contact-block">
              <div class="section-head">
                <span class="section-badge">5</span>
                <h2>Contact Information</h2>
              </div>
            <div class="section-body">
              <p>
                <strong>Developer Name:</strong> Orchestrade Technologies Pvt Ltd
              </p>
              <p>
                <strong>Support Email:</strong>
                <a href="mailto:info@tradebridge.co.in">info@tradebridge.co.in</a>
              </p>
            </div>
            </div>
          </div>
        </div>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Delete Your TradeBridge Account",
      meta: [
        {
          vmid: "description",
          name: "description",
          content:
            "Request deletion of your TradeBridge account and personal data.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.bg-delete-account {
  background: #f7faf4;
}

.delete-account-content {
  max-width: 1360px;
  margin: 0 auto;
}

.delete-account-card {
  background: #ffffff;
  border: 1px solid #e6efd8;
  border-radius: 16px;
  box-shadow: 0 12px 28px rgba(44, 75, 27, 0.09);
  padding: 1.2rem;
}

.hero-block {
  background: linear-gradient(180deg, #f7fbf2 0%, #ffffff 100%);
  border: 1px solid #edf3e4;
  border-radius: 12px;
  padding: 0.95rem;
  margin-bottom: 0.9rem;
}

.hero-kicker {
  display: inline-block;
  font-size: 0.78rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #4c7d36;
  font-weight: 700;
  margin-bottom: 0.35rem;
}

.page-heading {
  margin-bottom: 0.45rem;
  color: #1f2f18;
  font-size: 2rem;
  line-height: 1.2;
}

.intro-text {
  font-size: 1rem;
  color: #384537;
  margin-bottom: 0.6rem;
}

.section-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.7rem;
  margin-top: 0.7rem;
}

.section-card {
  border: 1px solid #edf3e4;
  background: #ffffff;
  border-radius: 12px;
  padding: 0.7rem;
}

.section-head {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin-bottom: 0.35rem;
}

.section-badge {
  width: 26px;
  height: 26px;
  min-width: 26px;
  border-radius: 50%;
  background: #3c9900;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.78rem;
  font-weight: 700;
}

.section-card h2 {
  margin: 0;
  color: #26421d;
  font-size: 1.1rem;
  line-height: 1.25;
}

.section-body {
  margin-left: 2.1rem;
}

.email-highlight {
  background: #f1f8e8;
  border: 1px dashed #8fb773;
  border-radius: 8px;
  padding: 0.7rem 0.9rem;
  display: inline-block;
}

.delete-account-content p,
.delete-account-content ul {
  margin-bottom: 0.45rem;
}

.delete-account-content ul {
  padding-left: 1.2rem;
}

.styled-list li {
  margin-bottom: 0.3rem;
}

.two-col-list {
  display: grid;
  grid-template-columns: 1fr;
  column-gap: 1.1rem;
}

@media (min-width: 768px) {
  .two-col-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.delete-account-content a {
  color: #3c9900;
  font-weight: 600;
}

.contact-block {
  background: #fbfdf9;
  border: 1px solid #edf3e4;
  border-radius: 10px;
}

@media (min-width: 992px) {
  .section-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.75rem;
  }
}

@media (max-width: 767px) {
  .delete-account-card {
    padding: 1.05rem;
    border-radius: 10px;
  }

  .delete-account-content {
    max-width: 100%;
  }

  .hero-block {
    padding: 0.9rem;
  }

  .section-head {
    align-items: flex-start;
  }

  .page-heading {
    font-size: 1.55rem;
  }

  .section-body {
    margin-left: 0;
  }
}
</style>
